module.exports = __webpack_public_path__ + "img/Project-1.b774ce4.png";